<template>
  <div>
    <vxe-toolbar>
      <template #buttons>
        <vxe-input
          v-model="filterName1"
          type="search"
          placeholder="Input a gene name"
          @keyup="searchEvent1"
        ></vxe-input>
        <vxe-button @click="exportDataEvent"
          ><a-icon type="cloud-download" /> Download</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      show-overflow
      row-id="id"
      size="small"
      ref="xTable"
      :row-config="{ height: 30, isCurrent: true, isHover: true }"
      :loading="loading3"
      :data="tableData3"
      align="center"
      header-align="center"
      class="my-sort"
      :column-config="{ isHover: true }"
      :sort-config="{
        showIcon: false,
        trigger: all,
        defaultSort: { field: 'percent', order: 'desc' },
      }"
      @header-cell-click="headerCellClickEvent"
    >
      <vxe-column
        field="genename"
        title="Gene name"
        width="130px"
        type="html"
        :titlePrefix="{
          icon: 'vxe-icon-question-circle-fill',
          useHTML: true,
          message: 'Click to access the perturbation details of the gene.',
        }"
      >
        <template #default="{ row }">
          <a
            v-if="row.percent != 0"
            @click="goPerturbgene(row.genename)"
            target="_blank"
            >{{ row.genename }}</a
          >
          <span v-else>{{ row.genename }}</span>
        </template>
      </vxe-column>
      <vxe-column field="ensg" title="Ensembl ID" type="html"></vxe-column>
      <vxe-column field="cell" title="Cell count" sortable type="html">
        <template #header="{ column }">
          <span>{{ column.title }}</span>
          <span class="custom-sort" :class="{ 'is-order': column.order }">
            <i
              :class="[
                column.order
                  ? `vxe-icon-sort-numeric-${column.order}`
                  : 'vxe-icon-sort',
              ]"
            ></i>
          </span> </template
      ></vxe-column>
      <vxe-column
        field="percent"
        title="Perturbation rate"
        sortable
        :formatter="formatPercentCell"
        type="html"
      >
        <template #header="{ column }">
          <span>{{ column.title }}</span>
          <span class="custom-sort" :class="{ 'is-order': column.order }">
            <i
              :class="[
                column.order
                  ? `vxe-icon-sort-numeric-${column.order}`
                  : 'vxe-icon-sort',
              ]"
            ></i>
          </span>
        </template>
      </vxe-column>
    </vxe-table>

    <vxe-pager
      background
      size="small"
      :loading="loading3"
      :current-page="tablePage3.currentPage"
      :page-size="tablePage3.pageSize"
      :total="tablePage3.totalResult"
      :page-sizes="[10, 20, 50, 100]"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        // 'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange3"
    >
    </vxe-pager>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  data() {
    return {
      //全表搜索
      filterName1: "",
      tempdata: [],
      //分页
      getdata: null, //必须要生成这个data
      loading3: false,
      tableData3: [],
      tablePage3: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  mounted() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/publications_freq.php", {
        params: { datasetId: this.$route.query.datasetId },
      })
      .then((response) => {
        //this.getdata = response.data;
        //清空之前选择的基因
        var filteredArray = response.data
          .filter(function (item) {
            return item.percent !== 0;
          })
          .sort((a, b) => b.percent - a.percent);
        this.getdata = filteredArray;
        this.findList3(this.getdata);
      });
  },
  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        if (column.order === "desc") {
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/publications_freq.php",
              {
                params: { datasetId: this.$route.query.datasetId },
              }
            )
            .then((response) => {
              //this.getdata = response.data;
              //清空之前选择的基因
              var filteredArray = response.data
                .filter(function (item) {
                  return item.percent !== 0;
                })
                .sort((a, b) => b.percent - a.percent);
              this.getdata = filteredArray;
              this.$refs.xTable.clearSort();
              this.findList3(this.getdata);
            });
          // axios
          //   .get(
          //     "http://research.gzsys.org.cn/perturbdb/API/clusters/clusters_all.php"
          //   )
          //   .then((response) => {
          //     this.getdata_detable = response.data;
          //     this.tableData_detable = response.data;
          //     this.$refs.xTable.clearSort();
          //     this.findList_detable(this.getdata_detable);
          //   });
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata = jiangxu;
          this.findList3(this.getdata);
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          var shengxu = this.getdata.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属升序排序
          this.getdata = shengxu;
          this.findList3(this.getdata);
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    formatPercentCell({ cellValue }) {
      return String(parseFloat(cellValue).toFixed(2)) + "%";
    },
    exportDataEvent() {
      if (this.tempdata.length != 0) {
        const list = this.tempdata;
        this.$refs.xTable.exportData({
          filename:
            this.filterName1 +
            "_related_freqTableOf_" +
            this.$route.query.datasetId,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.getdata;
        this.$refs.xTable.exportData({
          filename: "FreqTableOf_" + this.$route.query.datasetId,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    goPerturbgene(value) {
      let routeData = this.$router.resolve({
        name: "perturbedgenes",
        query: { datasetId: this.$route.query.datasetId, gene: value },
      });
      window.open(routeData.href, "_blank");
    },
    findList3(data) {
      this.loading3 = true;
      setTimeout(() => {
        const list = data;
        this.loading3 = false;
        this.tablePage3.totalResult = list.length;
        this.tableData3 = list.slice(
          (this.tablePage3.currentPage - 1) * this.tablePage3.pageSize,
          this.tablePage3.currentPage * this.tablePage3.pageSize
        );
      }, 300);
    },
    handlePageChange3({ currentPage, pageSize }) {
      this.tablePage3.currentPage = currentPage;
      this.tablePage3.pageSize = pageSize;
      if (this.tempdata.length == 0) {
        this.findList3(this.getdata);
      } else {
        this.findList3(this.tempdata);
      }
    },
    searchEvent1() {
      this.tablePage3.currentPage = 1; // 每次查找都定位到第一页
      const filterName = XEUtils.toValueString(this.filterName1)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["genename", "ensg", "cell", "percent"];
        const rest = this.getdata.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList3(this.tempdata);
      } else {
        this.tempdata = [];
        this.findList3(this.getdata);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
